import EmailImage from "@/assets/images/hosting/emailhosting-hero.webp";
import { Header } from "@/components/common";
import { Check } from "lucide-react";

export default function EmailHero() {
    const scrollToPricing = () => {
        const pricingSection = document.getElementById('pricing-section-emailhosting');
        if (pricingSection) {
            pricingSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <section className="relative w-full overflow-hidden">
            <Header />

            <div className="container pt-12 pb-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                    {/* Left - Image */}
                    <div>
                        <img
                            src={EmailImage}
                            alt="Email Services"
                            className="w-full h-[250px] md:h-[400px] lg:h-[400px] object-cover rounded-3xl"
                        />
                    </div>

                    {/* Right - Content */}
                    <div className="space-y-6">
                        <div>
                            <span className="text-blue-500">
                                Business Email & Productivity
                            </span>

                            <h1 className="text-4xl md:text-5xl font-bold leading-tight mt-2">
                                <span className="text-white">Power your team with </span>
                                <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                                    smarter solutions
                                </span>
                            </h1>
                        </div>

                        <div className="space-y-4">

                            {/* Item 1 */}
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-1">
                                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-300 text-base lg:text-lg">
                                    Professional email with your domain
                                </p>
                            </div>

                            {/* Item 2 */}
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-1">
                                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-300 text-base lg:text-lg">
                                    Microsoft 365 productivity tools
                                </p>
                            </div>

                            {/* Item 3 */}
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-1">
                                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-300 text-base lg:text-lg">
                                    Bundle & save more
                                </p>
                            </div>

                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                            <button
                                onClick={scrollToPricing}
                                className="px-8 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-purple-500/50 transition-all hover:scale-105 text-center"
                            >
                                Explore Plans & Pricing
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}